import { useTranslation } from 'react-i18next';
import { useSupportEmail } from '@/hooks/useSupportEmail';

type ForgotCodeModalProps = {
  open: boolean;
  onClose: () => void;
};

export default function ForgotCodeModal({ open, onClose }: ForgotCodeModalProps) {
  const { t } = useTranslation();
  const supportEmail = useSupportEmail();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <button
        type="button"
        aria-label="Fermer"
        onClick={onClose}
        className="absolute inset-0 h-full w-full cursor-pointer bg-foreground-950/50"
      />
      <div className="relative z-10 w-full max-w-md rounded-lg border border-background-200 bg-background-50 p-6 animate-fade-rise">
        <div className="flex items-start justify-between gap-4">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-accent-800">
            <i className="ri-question-line text-lg"></i>
          </span>
          <button
            type="button"
            onClick={onClose}
            aria-label="Fermer"
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-foreground-500 hover:bg-background-200"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
        <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
          {t('login.forgotTitle')}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t('login.forgotText')}</p>
        <a
          href={`mailto:${supportEmail}`}
          className="mt-5 inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-mail-send-line"></i>
          {supportEmail}
        </a>
      </div>
    </div>
  );
}